import React, { Component } from 'react';
import { t } from "./helper/ClientAppLocalizer";

export class Error extends Component {
    static displayName = Error.name;

    constructor() {
        super();

        this.state = {
            errorMessage: t("Authy.ProcessingError")
        };
    }

    render() {

        return (
            <div id="errorHandler">
                <h2>{this.state.errorMessage}</h2>
            </div>
            );
    }
}
